import ApartmentDocument from "../../model/document/ApartmentDocument";
import { UUID } from "../../utils/typeDefinitions";
import ApiProjectDocumentProvider from "./ApiProjectDocumentProvider";
import Document from "../../model/document/Document";
import IBimVisualizerApiProvider from "../bimVisualizerApi/IBimVisualizerApiProvider"
import IContextDocument from "../../model/document/IContextDocument";

class ApiApartmentDocumentProvider extends ApiProjectDocumentProvider {
    private apartmentUuid: UUID;
    constructor(projectUuid: UUID, apartmentUuid: UUID, apiProvider: IBimVisualizerApiProvider ) {
        super(projectUuid, apiProvider);
        this.apartmentUuid = apartmentUuid;
    } 

    getEntityId(): UUID {
        return this.apartmentUuid;
    }
    
    toContextDocument(doc: Document): IContextDocument {
        return new ApartmentDocument(this.projectUuid, this.apartmentUuid, doc);
    }

    async createInitialDocument(): Promise<IContextDocument> {
        const newDoc = new ApartmentDocument(   this.projectUuid, this.apartmentUuid,  
                                                new Document(`Document for apartment ${this.apartmentUuid}`));        
        newDoc.document.documentUuid = await this.apiProvider.addProjectDocument(newDoc.projectUuid, newDoc.apartmentUuid, newDoc.document.name) ?? "";
        return newDoc;
    }   
}

export default ApiApartmentDocumentProvider;